import DatePicker from '@components/common/DatePicker';
import LocationPicker from '@components/common/LocationPicker';
import { PANCHANG_TRANSLATIONS } from "../../../../languages/panchang";

interface ControlPanelProps {
    date: string;
    location: { name: string; latitude: number; longitude: number };
    loading: boolean;
    onDateChange: (date: string) => void;
    onLocationChange: (loc: { name: string; latitude: number; longitude: number }) => void;
    onFetchPanchang: () => void;
    language: string;
}

const ControlPanel = ({
    date,
    location,
    loading,
    onDateChange,
    onLocationChange,
    onFetchPanchang,
    language
}: ControlPanelProps) => {
    const langKey = language === 'hindi' ? 'Hindi' : 'English';
    const t = PANCHANG_TRANSLATIONS[langKey];

    return (
        <div className="bg-white/[0.08] border border-white/20 rounded-2xl p-4 md:p-6 shadow-2xl mb-8 md:mb-12">

            <div className="grid grid-cols-1 md:grid-cols-12 gap-6 items-end">
                <div className="md:col-span-4">
                    <label className="block text-xs font-bold text-purple-300 uppercase tracking-wider mb-2 font-sans">
                        {t.selectDate}
                    </label>
                    <DatePicker value={date} onChange={onDateChange} />
                </div>
                <div className="md:col-span-5">
                    <label className="block text-xs font-bold text-purple-300 uppercase tracking-wider mb-2 font-sans">
                        {t.location}
                    </label>
                    <LocationPicker
                        value={location.name}
                        onChange={(loc) =>
                            onLocationChange({
                                name: loc.name,
                                latitude: loc.latitude,
                                longitude: loc.longitude
                            })
                        }
                        placeholder={t.searchCity}
                        showCurrentLocationButton={false}
                    />
                </div>
                <div className="md:col-span-3">
                    <button
                        onClick={onFetchPanchang}
                        disabled={loading}
                        className="w-full bg-purple-600 hover:bg-purple-500 text-white font-bold py-3 md:py-4 px-6 rounded-2xl transition-colors shadow-lg hover:shadow-purple-600/40 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2 font-sans"
                    >
                        {loading ? <>{t.loading}</> : <>{t.getPanchang}</>}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ControlPanel;
